import { API_BASE_URL } from '../config';
import api from './axiosInstance';

export const uploadCommentTaskDoc = async ({
  commentTaskId,
  creatorId,
  caseId,
  files,
}) => {
  try {
    if (!files || files.length === 0) return;

    const filesDto = await Promise.all(
      files.map(async (file) => ({
        fileName: file.name,
        contentBase64: await toBase64(file),
        contentType: file.type,
        fileSize: file.size,
      }))
    );

    const payload = {
      commentTaskId,
      creatorId,
      caseId,
      files: filesDto,
    };

    const response = await api.post(
      `${API_BASE_URL}/CommentTaskDocumentSaas/upload`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );

    return response.data;
  } catch (error) {
    console.error(
      'Error al subir documentos del comentario:',
      error.response?.data || error.message
    );
    throw error;
  }
};

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });

export const fetchTaskTemplatesByService = async (
  serviceId,
  taskConfiguratorId = null
) => {
  try {
    let url = `/Task/Templates/by-service/${serviceId}`;

    if (taskConfiguratorId) {
      url += `?taskConfiguratorId=${taskConfiguratorId}`;
    }

    const res = await api.get(url);

    return res.data.map((t) => ({
      label: t.name,
      value: t.id,
      html: t.content,
      extraFields: t.extraFields || [],
    }));
  } catch (error) {
    console.error('Error fetching templates:', error);
    throw error;
  }
};

export async function downloadCommentTaskDoc({
  tipoComentario,
  commentableId,
  urlAttachment = null,
  nameAttachment = null,
}) {
  try {
    const response = await api.post(
      `${API_BASE_URL}/CommentTaskDocumentSaas/DowloadFile`,
      {
        TipoComentario: tipoComentario,
        CommentableId: commentableId,
        urlAttachment: urlAttachment,
        nameAttachment: nameAttachment,
      },
      {
        responseType: 'blob',
      }
    );

    const contentDisposition = response.headers['content-disposition'] || '';

    let fileName = nameAttachment ?? 'archivo';
    const match = contentDisposition.match(/filename="?(.+)"?/);
    if (match?.[1]) {
      fileName = decodeURIComponent(match[1]);
    }

    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error al descargar archivo:', error);
    throw error;
  }
}
